import { vnModule_knockoutJS } from '../../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS';
import { header } from '../header';
import { adminCreatives_template } from '../../components/templates/recruiting/adminCreatives_template';
import { startListLoading, stopListLoading } from '~/utils/listLoading';
export class admin_creatives extends vnModule_knockoutJS {
    getModuleName() {
        return 'admin_creatives';
    }
    buildContent() {
        const zoneHeader = this.getVnAppZone().app.getZoneByName('Header');
        const loadedModule = zoneHeader.loadedModule;
        loadedModule.setHeaderTitle('Creatives');
        this.tpl = new adminCreatives_template('adminCreativesTemplate', this.viewModel, this);
        this.template = this.tpl;
        return [this.tpl.build()];
    }
    fillPage() {
        this.getListData();
    }
    async getListData() {
        startListLoading(this, this.tpl.builtTemplate);
        try {
            const params = new URLSearchParams(this.tpl.getViewModelForRequest());
            const response = await fetch('/api/admin/rest/api/lead/offer/creatives?' + params.toString(), {
                credentials: 'same-origin',
            });
            const payload = await response.json();
            if (!response.ok) {
                alert(payload.message || 'Unable to load creatives.');
                return;
            }
            this.tpl.setCreatives((payload.data && payload.data.paginatedData) || payload.data || []);
        }
        finally {
            stopListLoading(this, this.tpl.builtTemplate);
        }
    }
    createCreative() {
        page('/admin/creative/new');
    }
    editCreative(id) {
        page('/admin/creative/' + id);
    }
    duplicateCreative(id) {
        page('/admin/creative-duplicate/' + id);
    }
}
